


















































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';

@Component
export default class AddressDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
}
